<div class="iching-matrix" role="grid" [attr.aria-label]="t('humanDesign.iching.cast.modeDirect')">
  <div class="iching-matrix__corner" role="presentation">
    <span>{{ t('humanDesign.iching.cast.matrixAbove') }} ↓</span>
    <span>{{ t('humanDesign.iching.cast.matrixBelow') }} →</span>
  </div>
  @for (column of columns; track column.id) {
    <div class="iching-matrix__head" role="columnheader" [attr.title]="t('humanDesign.iching.cast.matrixBelow') + ' ' + column.pinyin">
      {{ column.symbol }}
    </div>
  }
  @for (row of rows; track row.upper.id) {
    <div class="iching-matrix__head" role="rowheader" [attr.title]="t('humanDesign.iching.cast.matrixAbove') + ' ' + row.upper.pinyin">
      {{ row.upper.symbol }}
    </div>
    @for (cell of row.cells; track cell.number) {
      <button
        type="button"
        class="iching-matrix__cell"
        role="gridcell"
        [class.is-selected]="cell.number === selected()"
        [attr.aria-pressed]="cell.number === selected()"
        [attr.data-hexagram]="cell.number"
        (click)="hexagramSelected.emit(cell.number)"
      >
        <hd-iching-hexagram-figure [figure]="cell.figure" size="mini" />
        <span class="iching-matrix__number">{{ cell.number }}</span>
      </button>
    }
  }
</div>
